import { lang } from "src/language/lang"
import { isset } from "./default"

window.error_count = 0

export const error_handle = async (error, noticeOnly = false) => {
    console.log(error)
    try {
        if (error.response) {
            let log = ''
            if (error.response.data instanceof Blob) {
                log = await error.response.data.text()
            } else {
                log = error.response.data.detail
                let detail = error.response.data.detail
                if (Array.isArray(detail)) {
                    try {
                        log = detail
                            .map(error => `- ${error.loc[error.loc.length - 1]}: ${error.msg} (Giá trị: ${JSON.stringify(error.input)})`)
                            .join("\n");
                    } catch (e) {
                        log = JSON.stringify(detail, null, 4)
                    }
                } else if (typeof detail === 'object') {
                    log = JSON.stringify(detail, null, 4)
                }
            }


            if (error.response.status == 401 || error.response.status == 403) {
                if (window.isRefreshingToken) return
                let currentPage = window.location.pathname + window.location.search + window.location.hash
                let nextLink = window.location.origin + `/authen/goto?next=${btoa(currentPage)}`
                console.log('Redirecting to login page:', nextLink)
                window.location.href = `/authen/login?log=${lang(log)}&next=${btoa(nextLink)}`
                return
            }

            if (error.response.status == 502) {
                window.error_count++
                if (window.error_count >= 3) {
                    window.error_count = 0
                    window.location.href = `#/error`
                    return
                }
            }

            setTimeout(() => {
                if (noticeOnly) {
                    window.notice(lang(log), 'error')
                } else {
                    window.alert(lang(log))
                }
            }, 100)
            return
        }

        if (isset(error.result)) {
            if (!error.result) {
                setTimeout(() => {
                    if (noticeOnly) {
                        window.notice(lang(error.message), 'error')
                    } else {
                        window.alert(lang(error.message))
                    }
                }, 100)
                return
            }
        }

        if (error.code == "ERR_NETWORK") {
            window.error_count++
            if (window.error_count >= 3) {
                window.error_count = 0
                window.location.href = `#/error`
                return
            }
        }

    } catch (e) {
        console.log(e)
        setTimeout(() => {
            if (noticeOnly) {
                window.notice(lang(e.message), 'error')
            } else {
                window.alert(lang(e.message))
            }
        }, 100)
    }

}